import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import handleLogout from "../../redux/logout";
import blogBot from "../../assets/images/botblogrLogo-black.png";
import { Link } from "react-router-dom";
import PersonIcon from "@mui/icons-material/Person";
import LogoutIcon from "@mui/icons-material/Logout";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import i18next from "i18next";
import ReactSelect from "react-select";

function HelpCenterHeader() {
  const { t } = useTranslation();
  const userInfo = useSelector((state) => state?.auth).userInfo;
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const languageOptions = [
    {
      value: "fr",
      label: (
        <div className="flex items-center gap-2">
          🇫🇷 <span className="text-sm">Français</span>
        </div>
      ),
    },
    {
      value: "en",
      label: (
        <div className="flex items-center gap-2">
          🇬🇧 <span className="text-sm">English</span>
        </div>
      ),
    },
  ];

  const handleLanguageChange = (selectedOption) => {
    const selectedLang = selectedOption?.value;
    if (selectedLang) {
      i18next.changeLanguage(selectedLang);
    }
  };

  return (
    <>
      <nav className="bg-white fixed border-gray-200 z-40 w-full shadow-2">
        
        <div className="flex flex-wrap items-center justify-between mx-auto p-4 sm:pl-9 pl-6 sm:pr-7 pr-2">

            <div className="flex items-center sm:gap-6 gap-3 justify-between">
                <Link
                    to={"/dashboard"}
                    className="flex items-center sm:space-x-3 rtl:space-x-reverse pl-2"
                >
                    <img
                    src={blogBot}
                    className="w-[176px] md:ml-6 ml-0 object-contain"
                    />
                </Link>
            </div>

          <div className="flex items-center sm:gap-6 gap-3 justify-between">
            {/* RETURN TO DASHBOARD */}
            {userInfo &&
                <div className="relative flex justify-center items-center group">
                    <button
                        className="hover:bg-blue-200 *: bg-blue-100 text-white disabled:bg-slate-200 disabled:text-slate-400 font-light px-5 py-[6px] rounded flex items-center"
                        onClick={() => navigate("/dashboard")}
                    >
                        {t("Go-back-to-dashboard", "Retourner vers le dashboard")}
                    </button>
                </div>
            }

            {/* SWITCH LANGUAGE */}
            <ReactSelect
              options={languageOptions}
              value={languageOptions.find(
                (opt) => opt.value === i18next.language
              )}
              onChange={handleLanguageChange}
              isSearchable={false}
              menuPlacement="top"
              styles={{
                control: (base) => ({
                  ...base,
                  minHeight: "32px",
                  fontSize: "14px",
                  paddingLeft: "4px",
                }),
                menu: (base) => ({
                  ...base,
                  zIndex: 9999,
                }),
              }}
            />

            {/* MON COMPTE / SE CONNECTER */}
            <button
              title={userInfo ? "Mon compte" : "Se connecter"}
              className="h-8 w-8 flex items-center justify-center hover:text-blue-50 bg-Lightwhite rounded-full  text-gray font-light"
              onClick={() => navigate(userInfo ? "/profile" : "/login?redirect=feedbacks")}
            >
              <PersonIcon sx={{ fontSize: "20px" }} />
            </button>
            
            {/* LOG OUT */}
            {userInfo &&
                <button
                    title="Se déconnecter"
                    className="h-8 w-8 flex items-center justify-center hover:text-blue-50 bg-Lightwhite rounded-full  text-gray font-light"
                    onClick={() => handleLogout(dispatch)}
                >
                    <LogoutIcon
                        sx={{
                        fontSize: "20px",
                        }}
                    />
                </button>
            }
          </div>
        </div>
      </nav>
    </>
  );
}
export default HelpCenterHeader;